import React, { useState, useEffect } from 'react';
import {
  FiActivity, FiCalendar, FiUsers, FiMapPin,
  FiAward, FiHelpCircle, FiInbox, FiMessageSquare,
} from 'react-icons/fi';
import {
  sportTypeAPI, eventAPI, trainerAPI, gymAPI,
  achievementAPI, faqAPI, requestAPI, commentAPI,
} from '../../api/services';

const STAT_CONFIGS = [
  { key: 'sportTypes', label: 'Sport Types', icon: <FiActivity />, color: '#6c63ff', api: sportTypeAPI },
  { key: 'events', label: 'Events', icon: <FiCalendar />, color: '#ff8c42', api: eventAPI },
  { key: 'trainers', label: 'Trainers', icon: <FiUsers />, color: '#00d68f', api: trainerAPI },
  { key: 'gyms', label: 'Gyms', icon: <FiMapPin />, color: '#ff4757', api: gymAPI },
  { key: 'achievements', label: 'Achievements', icon: <FiAward />, color: '#ffa502', api: achievementAPI },
  { key: 'faqs', label: 'FAQs', icon: <FiHelpCircle />, color: '#2ed573', api: faqAPI },
  { key: 'requests', label: 'Requests', icon: <FiInbox />, color: '#5352ed', api: requestAPI },
  { key: 'comments', label: 'Comments', icon: <FiMessageSquare />, color: '#1e90ff', api: commentAPI },
];

const DashboardPage = () => {
  const [stats, setStats] = useState({});

  useEffect(() => {
    STAT_CONFIGS.forEach(({ key, api }) => {
      api.getAll()
        .then((r) => {
          const items = r.data?.data;
          setStats((prev) => ({ ...prev, [key]: Array.isArray(items) ? items.length : 0 }));
        })
        .catch(() => {
          setStats((prev) => ({ ...prev, [key]: 0 }));
        });
    });
  }, []);

  return (
    <div>
      <h1 style={{ fontSize: '1.5rem', fontWeight: 800, marginBottom: 24 }}>Dashboard</h1>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 16 }}>
        {STAT_CONFIGS.map(({ key, label, icon, color }) => (
          <div
            key={key}
            style={{
              background: 'var(--bg-card)',
              border: '1px solid var(--border)',
              borderRadius: 'var(--radius-lg)',
              padding: 24,
              transition: 'var(--transition)',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
              <div
                style={{
                  width: 42,
                  height: 42,
                  borderRadius: 12,
                  background: `${color}18`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color,
                  fontSize: '1.1rem',
                }}
              >
                {icon}
              </div>
            </div>
            <div style={{ fontSize: '1.8rem', fontWeight: 800, marginBottom: 4 }}>
              {stats[key] ?? '—'}
            </div>
            <div style={{ fontSize: '0.82rem', color: 'var(--text-muted)', fontWeight: 500 }}>
              {label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DashboardPage;
